import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-skeleton-text',
    styles: `
  @keyframes rkt-Skeleton--pulse {
    0% {
      background-color: rgba(0, 0, 0, 0.08);
    }
    50% {
      background-color: rgba(0, 0, 0, 0.04);
    }
    100% {
      background-color: rgba(0, 0, 0, 0.08);
    }
  }

  .rkt-Skeleton {
    background-color: rgba(0, 0, 0, 0.08);
    display: block;
    animation: 1.5s ease-in-out 0.5s infinite rkt-Skeleton--pulse;
    border-radius: 4px;
    height: 16px;
  }

  .rkt-Skeleton--default{
    width: 210px;
  }

  .rkt-Skeleton--short {
    width: 60px;
  }

  .rkt-Skeleton--med {
    width: 90px;
  }
  `,
    template: `<span class="rkt-Skeleton rkt-Skeleton--{{ width }}"></span>`,
    standalone: false
})
export class SkeletonTextComponent {
  @Input() width: 'default' | 'short' | 'med' = 'default';
}
